module.exports = __webpack_public_path__ + "img/mustela_maternite.36351696.jpg";